import { Inject, Injectable } from "@angular/core";
import { DEVICE_POLLING_REST_SERVICE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";
import { SummaryHttpService } from "./summary-http.service";
import {
    NmsAutoUpdaterManagerService
} from "@nms-ng2/app/shared/components/elements/nms-auto-updater/nms-auto-updater-manager.service";
import { RefreshIntervalService } from "@nms-ng2/app/shared/services/refresh-interval/refresh-interval.service";

/**
 * Gerencia o auto-updater da tela de Sumário.
 */
@Injectable({
    providedIn: "root"
})
export class SummaryAutoUpdateManagerService extends NmsAutoUpdaterManagerService {

    constructor(@Inject(DEVICE_POLLING_REST_SERVICE) readonly devicePollingRestService: any,
            readonly refreshInterval: RefreshIntervalService,
            private readonly summaryHttpService: SummaryHttpService) {
        super(devicePollingRestService, refreshInterval)
    }

    getManagedDevice(deviceId: number) {
        return this.summaryHttpService.getManagedDevice(deviceId);
    }
}
